"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    DiscGroup: ()=>DiscGroup
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const external_Disc_cjs_namespaceObject = require("./Disc.cjs");
const external_DiscGroup_variants_cjs_namespaceObject = require("./DiscGroup.variants.cjs");
const DiscGroup = ({ alt = '', contentData, isVertical, size })=>{
    const { baseSlot, discSlot } = (0, external_DiscGroup_variants_cjs_namespaceObject.discGroupVariants)({
        isVertical,
        size
    });
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        className: baseSlot(),
        children: contentData.map((contentItem, index)=>{
            const { content, contentType, emphasis, palette } = contentItem;
            const isLastDisc = index === contentData.length - 1;
            const hasMask = !isLastDisc;
            const marginClass = 0 === index ? '' : discSlot();
            return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                className: marginClass,
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Disc_cjs_namespaceObject.Disc, {
                    alt: alt ? `${alt}-${index}` : void 0,
                    isVertical: isVertical,
                    hasMask: hasMask,
                    content: content,
                    contentType: contentType,
                    emphasis: emphasis,
                    palette: palette,
                    size: size
                })
            }, `${contentType}-${index}`);
        })
    });
};
exports.DiscGroup = __webpack_exports__.DiscGroup;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "DiscGroup"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
